import { Record } from 'immutable';
import * as ActionTypes from 'automation-ui-action-features/constants/ActionTypes';
export default class GoToActionMetadata extends Record({
  actionType: ActionTypes.GO_TO
}, 'GoToActionMetadata') {}